import { use_slice_generation, use_slice_ml_asset } from '@/hooks/store/use_slices';
import { assert_instanceof, not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';
import { INVOCATION_SD__text_encoder } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__text_encoder';
import { useMemo } from 'react';

export function HOOK__ml_asset_lora_get_enabled_and_non_zero_weight(node_id: string) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { ml_assets_map } = use_slice_ml_asset(['ml_assets_map']);

  let { graph } = generation_current.tool;

  let out = useMemo(() => get_enabled_ml_asset_loras(), [node_id, graph, ml_assets_map]);

  function get_enabled_ml_asset_loras() {
    if (graph.is_stub()) return [];
    if (!graph.nodes_map.has(node_id)) return [];

    let node = graph.node__get(node_id);

    let out = [];

    if (node.type == ENUM__invocation_type.SD__TEXT_ENCODER) {
      assert_instanceof(node, INVOCATION_SD__text_encoder);

      let loras = node.clip.loras.find_source(graph).get_enabled_and_non_zero_weight_items();
      loras = loras.map(item => item.find_source(graph));

      let loras_hashes = loras.map(lora => lora.model.get_value());

      let map_by_hash = DTO__ml_asset.map_by_hash(Array.from(ml_assets_map.values()));

      for (let hash of loras_hashes) {
        if (!map_by_hash.has(hash)) continue;

        let ml_asset = map_by_hash.get_or_assert(hash);

        out.push(ml_asset);
      }

      //todo: we should to get edges also to node_sd_text_encoder->node_denoise.unet.loras
    } else {
      not_implemented_type(node.type);
    }

    return out;
  }

  return out;
}
